import {
    htGESDashboardSVE,
    htGESDashboardSVEChangePageType
} from '@/services/health-tracker/ges/V2/service'

const state = () => ({
    ges: {
        administrative: {
            current_page: 0,
            data: [],
            first_page_url: '',
            from: null,
            last_page: 0,
            last_page_url: '',
            next_page_url: null,
            path: '',
            per_page: 0,
            prev_page_url: '',
            to: null,
            total: 0
        },
        operative: {
            current_page: 0,
            data: [],
            first_page_url: '',
            from: null,
            last_page: 0,
            last_page_url: '',
            next_page_url: null,
            path: '',
            per_page: 0,
            prev_page_url: '',
            to: null,
            total: 0
        }
    }
})

const mutations = {
    SET_GES (state, { administrative, operative }) {
        state.ges.administrative = administrative
        state.ges.operative = operative
    },
    SET_CHANGE_PAGINATION_OF_GES(state, { data, type = 'operative' }) {
        if (state.ges[type]){ state.ges[type] = data }
    }
}

const actions = {
    async getHTGESDashboardSVE({commit}, { id = 0}) {
        const { administrative, operative} = await htGESDashboardSVE(id)
        commit('SET_GES', { administrative, operative })
    },

    async getHTGESDashboardSVEChangePageType({commit}, { id = 0, data = {} }) {
        if (data.type) {
            const options = {
                operative: 'operative',
                administrative: 'administrative'
            }
            if (options[data.type]) {
                const response = await htGESDashboardSVEChangePageType(id, data)
                commit('SET_CHANGE_PAGINATION_OF_GES', { data: response[data.type], type: options[data.type] })
            }
        }
    }

}

const getters = {
    getGESAdministrative: (state) => { return state.ges.administrative },
    getGESOperative: (state) => { return state.ges.operative },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
